import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';

export function downloadPurchaseOrderLines(orderLines, fileName, vendorType) {
  if (orderLines.length > 0) {
    if (vendorType === 'supplier') {
      downloadSupplierPurchaseLines(orderLines, fileName);
    } else {
      downloadWarehousePurchaseLines(orderLines, fileName);
    }
  } else {
    toast.error('There are no valid PO lines that can be downloaded', { id: 'download' });
  }
}

function downloadSupplierPurchaseLines(orderLines, fileName) {
  const xlsData = orderLines.map((line, index) => {
    const {
      vendorNo,
      whseVendorCode,
      documentNo,
      lineNo,
      itemNo,
      description,
      locationCode,
      quantity,
      vendorConfirmQty,
      vpFreightType,
      lossReason,
      expectedReceiptDate,
      plannedReceiptDate,
      whseConfirmQty,
      seaFreightConfirmedQty,
      actualReceiptDate,
      qtyDmged,
      vndrShpmntNo,
      mfgOriginCountry,
      directUnitCost,
      vpDirectUnitCost
    } = line;
    return {
      '#': index + 1,
      vendorNo,
      whseVendorCode,
      documentNo,
      lineNo,
      itemNo,
      type: 'purchase',
      description,
      locationCode,
      quantity,
      vendorConfirmQty,
      vpFreightType: vpFreightType === 'SeaRailAir' ? 'SeaRailAir' : 'TruckFreight',
      lossReason,
      expectedReceiptDate,
      plannedReceiptDate,
      whseConfirmQty:
        vpFreightType === 'SeaRailAir' ? seaFreightConfirmedQty || 0 : whseConfirmQty || 0,
      actualReceiptDate,
      qtyDmged,
      vndrShpmntNo,
      mfgOriginCountry,
      directUnitCost,
      vpDirectUnitCost
    };
  });
  const Heading = [
    [
      '#',
      'Vendor Code',
      'Warehouse Code',
      'Order No',
      'Line No',
      'Item No',
      'Type',
      'Description',
      'Location Code',
      'Quantity',
      'Vendor Confirm Quantity',
      'Shipping Method',
      'Root Cause',
      'Expected GRD (yyyy/mm/dd)',
      'Planned GRD (Not updatable)',
      'Warehouse Confirm Quantity',
      'Warehouse Arrival Date (yyyy/mm/dd)',
      'Quantity Damaged',
      'Vendor Shipment Number',
      'Country Of Origin',
      'Original Unit price',
      'Confirmed Unit Price'
    ]
  ];
  const wscols = [
    { width: 5 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 10 },
    { width: 30 },
    { width: 10 },
    { width: 40 },
    { width: 20 },
    { width: 10 },
    { width: 25 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 30 },
    { width: 25 },
    { width: 35 },
    { width: 20 },
    { width: 30 },
    { width: 20 },
    { width: 10 },
    { width: 10 }
  ];
  // Had to create a new workbook and then add the header
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet([]);
  ws['!cols'] = wscols;
  XLSX.utils.sheet_add_aoa(ws, Heading);
  // Starting in the second row to avoid overriding and skipping headers
  XLSX.utils.sheet_add_json(ws, xlsData, { origin: 'A2', skipHeader: true });

  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  // Download
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

function downloadWarehousePurchaseLines(orderLines, fileName) {
  orderLines = orderLines.filter((line) => line !== undefined);
  const xlsData = orderLines.map((line, index) => {
    const {
      vendorNo,
      whseVendorCode,
      documentNo,
      lineNo,
      itemNo,
      description,
      locationCode,
      vpFreightType,
      expectedReceiptDate,
      plannedReceiptDate,
      expectedDeliveryDate,
      actualShippingDate,
      whseConfirmQty,
      seaFreightConfirmedQty,
      actualReceiptDate,
      qtyDmged,
      vndrShpmntNo
    } = line;
    return {
      '#': index + 1,
      vendorNo,
      whseVendorCode,
      documentNo,
      lineNo,
      itemNo,
      type: 'purchase',
      description,
      locationCode,
      vpFreightType: vpFreightType === 'SeaRailAir' ? 'SeaRailAir' : 'TruckFreight',
      expectedReceiptDate,
      plannedReceiptDate,
      expectedDeliveryDate,
      actualShippingDate,
      warehouseQuantity:
        vpFreightType === 'SeaRailAir' ? seaFreightConfirmedQty || 0 : whseConfirmQty || 0,
      actualReceiptDate,
      qtyDmged,
      vndrShpmntNo
    };
  });
  const Heading = [
    [
      '#',
      'Vendor Code',
      'Warehouse Code',
      'Order No',
      'Line No',
      'Item No',
      'Type',
      'Description',
      'Location Code',
      'Shipping Method',
      'Expected GRD (yyyy/mm/dd)',
      'Planned GRD (Not updatable)',
      'Expected Delivery Date (yyyy/mm/dd)',
      'Actual Shipping Date (yyyy/mm/dd)',
      'Warehouse Confirm Quantity',
      'Warehouse Arrival Date (yyyy/mm/dd)',
      'Quantity Damaged',
      'Vendor Shipment Number'
    ]
  ];
  const wscols = [
    { width: 5 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 10 },
    { width: 20 },
    { width: 10 },
    { width: 40 },
    { width: 15 },
    { width: 10 },
    { width: 20 },
    { width: 25 },
    { width: 20 },
    { width: 25 },
    { width: 25 },
    { width: 40 },
    { width: 40 },
    { width: 25 },
    { width: 40 },
    { width: 20 },
    { width: 25 }
  ];
  // Had to create a new workbook and then add the header
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet([]);

  ws['!cols'] = wscols;
  XLSX.utils.sheet_add_aoa(ws, Heading);

  // Starting in the second row to avoid overriding and skipping headers
  XLSX.utils.sheet_add_json(ws, xlsData, { origin: 'A2', skipHeader: true });

  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // Download
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

export function downloadTransferOrderLines(orderLines, vendorNo, fileName) {
  const xlsData = orderLines.map((line, index) => {
    const {
      vendorCodeWhseVP,
      documentNo,
      lineNo,
      itemNo,
      description,
      expectedReceiptDate,
      actualReceiptDate,
      qtyToReceive,
      qtyDmged,
      externalDocumentNo
    } = line;
    return {
      '#': index + 1,
      vendorNo,
      vendorCodeWhseVP,
      documentNo,
      lineNo,
      itemNo,
      type: 'transfer',
      description,
      expectedReceiptDate,
      qtyToReceive,
      actualReceiptDate,
      qtyDmged,
      externalDocumentNo
    };
  });
  const Heading = [
    [
      '#',
      'Vendor Code',
      'Warehouse Code',
      'Order No',
      'Line No',
      'Item No',
      'Type',
      'Description',
      'Expected GRD (yyyy/mm/dd)',
      'Quantity Received',
      'Warehouse Arrival Date (yyyy/mm/dd)',
      'Quantity Damaged',
      'External Document No'
    ]
  ];
  const wscols = [
    { width: 10 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 10 },
    { width: 30 },
    { width: 10 },
    { width: 40 },
    { width: 40 },
    { width: 20 },
    { width: 40 },
    { width: 20 },
    { width: 40 },
    { width: 30 }
  ];
  // Had to create a new workbook and then add the header
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet([]);

  ws['!cols'] = wscols;
  XLSX.utils.sheet_add_aoa(ws, Heading);

  // Starting in the second row to avoid overriding and skipping headers
  XLSX.utils.sheet_add_json(ws, xlsData, { origin: 'A2', skipHeader: true });

  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
